import { baseTheme } from "./brands/base.theme.js";
import { themes } from "./themes.types.js";
import { toKebabCase } from "../utilities/index.js";
import { createTheme, mergeThemeOverrides, DEFAULT_THEME } from "@mantine/core";
const customVariants = createTheme({
  components: {}
});
const themeResolver = (theme) => {
  const merged = mergeThemeOverrides(
    DEFAULT_THEME,
    customVariants,
    baseTheme,
    themes[theme]
  );
  return merged;
};
const toCssVariables = (obj, parentKey = "") => {
  const flatObject = {};
  Object.keys(obj).forEach((key) => {
    let groupKey = parentKey;
    if (groupKey === "color-tokens") {
      groupKey = "";
    }
    const newKey = groupKey ? `--figurine-${toKebabCase(groupKey)}-${toKebabCase(key)}` : toKebabCase(key);
    if (typeof obj[key] === "object" && obj[key] !== null) {
      Object.assign(flatObject, toCssVariables(obj[key], newKey));
    } else {
      flatObject[newKey] = obj[key];
    }
  });
  return flatObject;
};
export {
  themeResolver,
  toCssVariables
};
